import { signal } from "@preact/signals-react"

export const sellerDetailsData = signal([])
export const isLoadingSellerDetails = signal(true)